/*
 * SMOON — Fiches MOVE : comparatif Active / Perf (sections/move-comparatif.liquid).
 *
 * La bascule marche sans ce script : les repères de la photo et le lien « Voir … »
 * sont des <label> des boutons radio. Mais un clic sur un <label> donne le focus
 * au bouton radio, et le navigateur remonte d'un coup jusqu'au sélecteur. Ici on
 * coche sans déplacer la page depuis un repère, et depuis « Voir … » (bas de la
 * carte) on remonte en douceur jusqu'à la photo pour montrer la nouvelle gamme.
 * La classe mvc--anim réserve le fondu de la carte aux bascules (pas au chargement).
 *
 * Écouteurs posés une seule fois sur document : le script peut être réémis par
 * l'éditeur de thème sans doubler les écouteurs.
 */
(() => {
  if (window.smoonMoveComparatif) return;
  window.smoonMoveComparatif = true;

  const animer = (radio) => radio.closest('.mvc')?.classList.add('mvc--anim');

  document.addEventListener('change', (event) => {
    if (event.target.matches('.mvc__radio')) animer(event.target);
  });

  document.addEventListener('click', (event) => {
    const label = event.target.closest('.mvc__spot, .mvc__other-link');
    if (!label) return;
    const radio = document.getElementById(label.htmlFor);
    if (!radio) return;

    event.preventDefault();
    animer(radio);
    radio.checked = true;
    radio.focus({ preventScroll: true });

    if (!label.classList.contains('mvc__other-link')) return;
    const section = radio.closest('.mvc');
    const cible = section && (section.querySelector('.mvc__media') || section.querySelector('.mvc__head'));
    if (!cible || cible.getBoundingClientRect().top >= 0) return;
    const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    cible.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
  });
})();
